export default "__VITE_ASSET__eee4b1ac__"